// extracted by mini-css-extract-plugin
export default {"closeIcon":"CloseBannerButton_closeIcon__lwAFP"};